import { useState } from "react";
import { Box, Fab, makeStyles } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import TextInputField from "../ui/TextInputField";

interface Props {
  existingPackageNames: string[];
  onPackageNameConfirmed: (packageName: string) => void;
}

const useStyles = makeStyles(theme => ({
  button: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1)
  }
}));

const KitPackageName = (props: Props) => {
  const classes = useStyles();
  const [packageName, setPackageName] = useState<string>();

  const handleConfirmPackageNameClicked = () => {
    if (packageName) {
      props.onPackageNameConfirmed(packageName);
      setPackageName('');
    } else {
      console.warn('No package name provided to confirm');
    }
  };

  const isPackageNameAlreadyUsed = (packageName: string) => props.existingPackageNames.includes(packageName);

  const isConfirmPackageNameDisabled = () => !packageName || isPackageNameAlreadyUsed(packageName);

  return <Box>
      <TextInputField
        label='Nowa paczka'
        onValueChange={ setPackageName }
        calculatedValue={ packageName }
        errorMessage={ value => (value !== null && isPackageNameAlreadyUsed(value)) ? 'Istnieje już paczka o tej nazwie' : null }
      />
      <Fab
        className={ classes.button }
        aria-label='add'
        color='primary'
        onClick={ handleConfirmPackageNameClicked }
        size='small'
        disabled={ isConfirmPackageNameDisabled() }
      >
        <AddIcon />
      </Fab>
    </Box>
};

export default KitPackageName;